import AnalyticsWebClient, { originType } from '@atlassiansox/analytics-web-client';

import { appConfig } from '../../utils/get-env-config';

export const client: AnalyticsWebClient = new AnalyticsWebClient({
	product: 'csm',
	subproduct: 'widget',
	version: process.env.PACKAGE_VERSION,
	env: appConfig.env,
	origin: originType.WEB,
});
